module.exports = __webpack_public_path__ + "media/svg/fm-c916f997.svg";